/**
 * Обзор района в загрузке (agroai-6al.49): тот же порядок и те же размеры
 * блоков, что у готовой страницы (agroai-0e8), — шапка, «Сейчас в районе»,
 * «Где нужно разобраться», пять показателей, «Находки», графики 7/5, справка
 * («От решения к результату», свёрнутые блоки). Данные встают на место без сдвига.
 */
import { defineMessages } from '../../../i18n/define';
import { useT } from '../../../i18n/hooks';
import { Grid } from '../../ui/Card';
import { ProblemsBoardBodySkeleton } from '../../astra/problems/ProblemsBoard';
import {
  Skeleton,
  SkeletonCard,
  SkeletonChart,
  SkeletonHeader,
  SkeletonKpi,
  SkeletonList,
  SkeletonPage,
} from '../../ui/Skeleton';

const m = defineMessages({
  title: { id: 'district.skeleton.title', defaultMessage: 'Обзор района', description: 'Заголовок страницы «Обзор района» в заглушке загрузки (хоким, менеджер)' },
  label: { id: 'district.skeleton.label', defaultMessage: 'обзор района', description: 'Что загружается: подпись заглушки для чтеца с экрана, строчными' },
  now: { id: 'district.skeleton.now', defaultMessage: 'Сейчас в районе', description: 'Заголовок карточки в заглушке загрузки: агроциклы, работы в поле и что скоро' },
  flow: { id: 'district.skeleton.flow', defaultMessage: 'От решения к результату', description: 'Заголовок карточки в заглушке загрузки: шаги поручений от назначения до проверки' },
  problems: { id: 'district.skeleton.problems', defaultMessage: 'Где нужно разобраться', description: 'Заголовок карточки в заглушке загрузки: разбор проблем по типам' },
  insights: { id: 'district.skeleton.insights', defaultMessage: 'Находки', description: 'Заголовок карточки в заглушке загрузки: находки ночного сканера' },
  season: { id: 'district.skeleton.season', defaultMessage: 'Ход работ сезона', description: 'Заголовок графика в заглушке загрузки: накопленная доля выполненного по неделям' },
  pace: { id: 'district.skeleton.pace', defaultMessage: 'Темп кампании', description: 'Заголовок графика в заглушке загрузки: темп текущей кампании по дням' },
});

export function DistrictSkeleton({ title }: { title?: string }) {
  const t = useT();
  return (
    <SkeletonPage label={t(m.label)} className="district">
      <SkeletonHeader title={title ?? t(m.title)} controls={3} />
      <SkeletonCard quiet title={t(m.now)} height={220}>
        <SkeletonList quiet items={3} />
      </SkeletonCard>
      <SkeletonCard quiet size="lg" title={t(m.problems)} className="pboard-card">
        <div className="pboard__tabs" aria-hidden="true">
          {Array.from({ length: 5 }, (_, i) => <Skeleton key={i} variant="block" width={i === 0 ? 86 : 112} height={36} className="skel--control" />)}
        </div>
        <Skeleton width="70%" className="skel--caption" />
        <ProblemsBoardBodySkeleton quiet />
      </SkeletonCard>
      <div className="district-kpis">
        {Array.from({ length: 5 }, (_, i) => <SkeletonKpi key={i} quiet />)}
      </div>
      <SkeletonCard quiet title={t(m.insights)}>
        <SkeletonList quiet items={5} tone="soft" />
      </SkeletonCard>
      <Grid cols="7-5">
        <SkeletonChart quiet title={t(m.season)} height={280} bars={20} captionLines={2} />
        <SkeletonChart quiet title={t(m.pace)} height={280} bars={10} captionLines={2} />
      </Grid>
      <SkeletonCard quiet title={t(m.flow)} height={160}>
        <DecisionFlowSkeleton />
      </SkeletonCard>
      <Skeleton variant="block" width="100%" height={56} className="skel--disclosure" />
    </SkeletonPage>
  );
}

/** Четыре шага поручений плашками — в сетке `district-flow`. */
export function DecisionFlowSkeleton() {
  return (
    <ol className="district-flow" aria-hidden="true">
      {Array.from({ length: 4 }, (_, i) => (
        <li key={i}>
          <span className="district-flow__step">
            <Skeleton width="70%" className="skel--caption" />
            <Skeleton variant="block" width="40%" height={24} />
          </span>
        </li>
      ))}
    </ol>
  );
}
